import type { Result } from '@de/types/result';

/**
 * Narrow an unknown value to a legacy `Result` for the DSL action
 * boundary. The DSL hands off a repeater row verbatim (e.g.
 * `results.openLeadFlow` via `params.result: '{{item}}'`, or
 * `comparison.toggle` via `params.item`), so the host must guard the
 * shape before forwarding it to a domain handler -- the action
 * dispatcher factory stays presentation- and domain-agnostic.
 *
 * A numeric `programId` is the cheapest discriminator that every
 * result-card item carries (`ResultCardItem = Result & { card }`); it
 * matches the guard the imperative path already relies on and keeps
 * malformed/empty `{{...}}` interpolations (which resolve to `undefined`
 * or a partial object) from reaching the governed runtime.
 */
export function isResultLike(value: unknown): value is Result {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { programId?: unknown }).programId === 'number'
  );
}
